import { create } from "zustand";
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "./localStores";
import Cookies from "js-cookie";
const ACCESS_TOKEN = "token-pv";
/* interface AuthUser {
  accountNo: string
  email: string
  role: string[]
  exp: number
}

interface AuthState {
  auth: {
    user: AuthUser | null
    setUser: (user: AuthUser | null) => void
    accessToken: string
    setAccessToken: (accessToken: string) => void
    resetAccessToken: () => void
    reset: () => void
  }
}
 */
export const useTranslateStore = create()((set) => {
  const lang = Cookies.get("googtrans") === "/auto/en" ? "en" : "es";
  return {
    translate: {
      lang,
      setLang: (lang) =>
        set((state) => ({ ...state, translate: { ...state.translate, lang } })),
    },
  };
});
